const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
};

export const formElementFields = [
  
  {
    id: "customer_name",
    label: "Customer Name",
    placeHolder: "Enter customer name",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 200,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
    disabled: true,
  },
  {
    id: "job_id",
    label: "Service",
    placeHolder: "Select service",
    type: "select",
    md: 6,
    isRequired: true,
    options: ["General", "Into Store", "Out of Store", "Moving", "Packing", "Storage"],
  },
  {
    id: "handled_by",
    label: "Handler",
    placeHolder: "Select handler",
    type: "select",
    md: 6,
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    options: [], // Will be populated dynamically with users
    isRequired: false,
  },
  {
    id: "reported_date",
    label: "Reported Date",
    placeHolder: "Select date",
    type: "date",
    md: 6,
    isRequired: true,
  },
  {
    id: "title",
    label: "Title",
    placeHolder: "Short description as reported",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 200,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "reported_by",
    label: "Reported By",
    placeHolder: "Select who reported",
    type: "text",
    md: 6,
    isRequired: true,
  },
  {
    id: "priority",
    label: "Urgency",
    placeHolder: "Select urgency",
    type: "select",
    md: 6,
    isRequired: true,
    options: ["General", "Immediate", "Urgent"],
  },
  {
    id: "status",
    label: "Stage",
    placeHolder: "Select stage",
    type: "select",
    md: 6,
    isRequired: false,
    options: [
      "Initiated",
      "Assigned: user handler",
      "Data acquiring",
      "Waiting customer",
      "Waiting quote",
      "Waiting repairer",
      "With insurers",
      "Offer made",
      "Offer accepted",
      "Court papers",
      "Court date set",
      "Settled/Resolved",
      "Unresolved",
    ],
  },
      {
    id: "recovered",
    label: "Recovered",
    placeHolder: "Enter recovered",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    // isRequired: true,
    md: 6,
  },
  {
    id: "description",
    label: "Details",
    placeHolder: "Enter complaint details",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 2000,
      rows: 5,
    },
    isRequired: false,
  },
];

export const PROGRESS_FORM_ELEMENT_FIELDS = [
   {
    id: "date",
    label: "Date",
    placeHolder: "Select",
    type: "date",
    md: 2,
    isRequired: true,
  },
   {
    id: "description",
    label: "Details",
    placeHolder: "Enter complaint details",
    type: "text",
    md: 7,
    inputProps: {
      maxLength: 150,
    },
    isRequired: true,
  },
  {
    id: "added_by",
    label: "User",
    placeHolder: "Select",
    type: "select",
    md: 2,
    options: [], // Will be populated dynamically with users
    isRequired: true,
  },
];


export const validateComplaintForm = (
  formData: any,
  fields: any[]
) => {
  let errors: any = {};

  fields.forEach((field) => {
    if (field.isRequired) {
      const value = formData[field.id];

      // special case job_id OR job_name
      if (field.id === "job_id") {
        if (!formData?.job_id && !formData?.job_name) {
          errors["job_id"] = true;
        }
      } 
      else if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        errors[field.id] = true;
      }
    }
  });

  return errors;
};